import { FormInput, useFormContext } from "@4uhub/lib4uhub";
import { Grid, FormHelperText } from "@mui/material";
import { memo, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAutomationRules } from "../../../../../../../store/contexts/AutomationRulesContext";
import { TAutomationTemplateForm } from "./automationTemplateSchema";

const translationPath =
  "chatBot.page.automations.automationMessageTicketDefaulDoc.";

export const InsurancesField = memo(() => {
  const { t } = useTranslation();

  const { automation } = useAutomationRules();

  const { setValue } = useFormContext<TAutomationTemplateForm>();

  useEffect(() => {
    setValue("automation", automation);
  }, [automation, setValue]);

  if (!automation || automation.code === "7") return null;
  return (
    <Grid item xs={12} sm={12}>
      <FormInput
        size="small"
        name="insurances"
        fullWidth
        label={t(translationPath + "insurances") || "insurances"}
      />
      <FormHelperText>
        {t(translationPath + "insurancesMessageHelper")}
      </FormHelperText>
    </Grid>
  );
});
